import { useEffect } from "react";
import debounce from "lodash/debounce";
export const useTriggerEvents = (config) => {
    const { close, closeOnIntent, isTouch, mode, openOnDelay, toggle, triggerRef } = config;
    useEffect(() => {
        if (!triggerRef.current) {
            return;
        }
        const trigger = triggerRef.current;
        if (mode === "tooltip") {
            if (isTouch) {
                const preventUserSelect = () => {
                    document.body.style.setProperty("user-select", "none");
                    document.body.style.setProperty("-webkit-user-select", "none");
                    document.body.style.setProperty("-webkit-touch-callout", "none");
                };
                const restoreUserSelect = () => {
                    document.body.style.removeProperty("user-select");
                    document.body.style.removeProperty("-webkit-user-select");
                    document.body.style.removeProperty("-webkit-touch-callout");
                };
                const onTouchStart = () => {
                    preventUserSelect();
                    openOnDelay();
                };
                const onTouchEnd = () => {
                    restoreUserSelect();
                    close();
                };
                // use touch events
                trigger.addEventListener("touchstart", onTouchStart);
                trigger.addEventListener("touchend", onTouchEnd);
                return () => {
                    restoreUserSelect();
                    trigger.removeEventListener("touchstart", onTouchStart);
                    trigger.removeEventListener("touchend", onTouchEnd);
                };
            }
            // use mouse events
            trigger.addEventListener("mouseenter", openOnDelay);
            trigger.addEventListener("mouseleave", closeOnIntent);
            trigger.addEventListener("click", close);
            return () => {
                trigger.removeEventListener("mouseenter", openOnDelay);
                trigger.removeEventListener("mouseleave", close);
            };
        }
        // Mode === "popover"
        const maybeToggle = (e) => {
            // Don't add events to disabled popovers (we do allow them for tooltips)
            if (triggerRef.current?.hasAttribute("disabled") ||
                triggerRef.current?.getAttribute("aria-disabled") === "true") {
                return;
            }
            toggle(e);
        };
        if (isTouch) {
            // Prevents iOS VoiceOver double-tap gesture from opening and immediately closing the overlay
            const debouncedToggle = debounce(maybeToggle, 100);
            trigger.addEventListener("touchend", debouncedToggle);
            return () => {
                debouncedToggle.cancel();
                trigger.removeEventListener("touchend", debouncedToggle);
            };
        }
        // Not touch
        trigger.addEventListener("click", maybeToggle);
        return () => {
            trigger.removeEventListener("click", maybeToggle);
        };
    }, [close, closeOnIntent, isTouch, mode, openOnDelay, toggle, triggerRef]);
};
